import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'ja', label: '日本語', flag: 'jp' },
  { code: 'en', label: 'English', flag: 'us' },
  { code: 'zh', label: '中文', flag: 'cn' },
];

const flagUrl = (cc: string) => `/flags/${cc}.svg`;

function LanguageSelect() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const current =
    LANGUAGES.find((l) => (i18n.resolvedLanguage || i18n.language || '').startsWith(l.code)) ??
    LANGUAGES[0];

  // 外側クリック / Escキーで閉じる
  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const select = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="lang-dropdown" ref={ref}>
      <button
        type="button"
        className="lang-trigger"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label="Language"
        onClick={() => setOpen((v) => !v)}
      >
        <img className="lang-flag" src={flagUrl(current.flag)} alt="" width={20} height={15} />
        <span className="lang-label">{current.label}</span>
        <svg className={`lang-caret ${open ? 'open' : ''}`} width="10" height="6" viewBox="0 0 10 6" aria-hidden="true">
          <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.5" fill="none" />
        </svg>
      </button>

      {open && (
        <ul className="lang-menu" role="listbox">
          {LANGUAGES.map((l) => (
            <li key={l.code}>
              <button
                type="button"
                role="option"
                aria-selected={l.code === current.code}
                className={`lang-option ${l.code === current.code ? 'active' : ''}`}
                onClick={() => select(l.code)}
              >
                <img className="lang-flag" src={flagUrl(l.flag)} alt="" width={20} height={15} />
                <span>{l.label}</span>
                {l.code === current.code && <span className="lang-check">✓</span>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LanguageSelect;
